import React from 'react';
import { motion } from 'framer-motion';

const techCategories = [
  { name: 'Frontend', items: ['React', 'Next.js', 'HTML5', 'CSS3', 'Tailwind CSS'] },
  { name: 'Backend', items: ['Node.js', 'Express', 'Supabase', 'PostgreSQL', 'Firebase'] },
  { name: 'Cloud', items: ['Cloudflare', 'Docker', 'Nginx', 'Linux'] },
  { name: 'CMS', items: ['WordPress', 'Shopify'] },
  { name: 'Creative', items: ['Figma', 'Adobe CC', 'HostFig Studio', 'Capture One'] }
];

const TechStack = () => {
  return (
    <section className="py-24 bg-slate-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="text-center mb-20">
          <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-6">Technologies We Work With</h2>
          <p className="text-slate-500 text-lg">We use industry-leading tools to build high-performance digital products.</p>
        </div>

        <div className="flex flex-col gap-12">
          {techCategories.map((cat, i) => (
            <div key={i} className="flex flex-col md:flex-row md:items-center gap-6">
              <div className="w-32 shrink-0 font-bold text-slate-400 uppercase tracking-widest text-[12px]">{cat.name}</div>
              <div className="flex flex-wrap gap-3">
                {cat.items.map((item, idx) => (
                  <span 
                    key={idx} 
                    className="px-6 py-2 bg-white border border-slate-200 rounded-full text-slate-700 font-bold text-sm shadow-sm hover:border-blue-500 hover:text-blue-600 transition-all cursor-default"
                  >
                    {item}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechStack;